import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-updateandsave-dialog',
  template: `
    <div mat-dialog-content class="tw-m-6 tw-p-6 tw-bg-white tw-rounded-2xl tw-shadow-lg">
      <div class="tw-text-center tw-mb-6">
        <h2 class="tw-text-2xl tw-font-semibold tw-text-gray-800">{{ data.title || 'Save Options' }}</h2>
        <p class="tw-text-gray-600 tw-text-base tw-mt-2">{{ data.message || 'How would you like to proceed?' }}</p>
      </div>

      <div mat-dialog-actions class="tw-flex tw-flex-col tw-gap-4">
        <button
          mat-raised-button
          class="tw-rounded-full tw-py-3 tw-text-lg tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-font-semibold tw-shadow-md"
          (click)="dialogRef.close('saveAndTranslate')"
        >
          🌍 Save and Translate
        </button>

        <button
          mat-raised-button
          class="tw-rounded-full tw-py-3 tw-text-lg tw-bg-green-600 hover:tw-bg-green-700 tw-text-white tw-font-semibold tw-shadow-md"
          (click)="dialogRef.close('saveOnly')"
        >
          💾 Save without Translation
        </button>

        <button
          mat-raised-button
          class="tw-rounded-full tw-py-3 tw-text-lg tw-bg-gray-500 hover:tw-bg-gray-600 tw-text-white tw-font-semibold tw-shadow-md"
          (click)="dialogRef.close('cancel')"
        >
          ❌ Cancel
        </button>
      </div>
    </div>
  `,
})

  export class UpdateAndSaveDialogComponent {
    constructor(
      public dialogRef: MatDialogRef<UpdateAndSaveDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
    onClick(saveAndTranslate: boolean): void {
      this.dialogRef.close(saveAndTranslate);
    }
  }